
import { Project } from '@/models/bookings';
import Vue from 'vue';

export default Vue.extend({
  props: {
    project: {
      type: Number,
      required: false,
    },
    projects: {
      type: Array,
      required: true,
    },
    rules: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      data_project: this.project,
      data_projects: this.projects as Project[],
      search_project: '',
    };
  },

  methods: {
    onChange(): void {
      this.$emit('change', this.data_project);
    },
  },

  computed: {
    getProjects(): Project[] {
      return !this.search_project
        ? this.data_projects
        : this.data_projects.filter((project) =>
            project.name.toLowerCase().includes(this.search_project.toLowerCase()),
          );
    },
  },
});
